import { render, staticRenderFns } from "./transactedProp.vue?vue&type=template&id=84277e7a&scoped=true&"
import script from "./transactedProp.vue?vue&type=script&lang=js&"
export * from "./transactedProp.vue?vue&type=script&lang=js&"
import style0 from "./transactedProp.vue?vue&type=style&index=0&id=84277e7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84277e7a",
  null
  
)

export default component.exports